import { ArsListingState } from "../interface";

/**
 * Marks the listing state as clean after changes have been sent.
 *
 * @param state - Current ARS listing state
 * @returns Updated ARS listing state with change tracking cleared
 */
export const arsl_changeSent = <T>(state: ArsListingState<T>): ArsListingState<T> => ({
  ...state,
  changed: false,
});
